import React, { Component } from "react";
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { InputField } from "../../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../../common/custom-form/select-filter.component";
import { TextArea } from "../../../../../common/custom-form/custom-textarea.component";
import { CustomDropdown } from "../../../../../common/custom-form/custom-dropdown.component";
import { Button } from "react-bootstrap";
import { DetailsDataTable } from "../../../../inventory/DetailsView/details-table/details-table.component";
export class PlanManagement extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            showTable: false,
            showRate: false,
            detailsDropdown:[
                {
                    "title":"Plan Features",
                    "subTitle":"Feature Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                },{
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                },{
                    "title":"Plan Rates",
                    "subTitle":"Rate Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                }, {
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                }
            ],
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
               dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
        }
    }

    showTable(index) {
        const newDetailsDropdown = [...this.state.detailsDropdown];
        newDetailsDropdown[index].showTable = !newDetailsDropdown[index].showTable;       
        this.setState({ detailsDropdown: newDetailsDropdown });
    }

    render() {
        return(
            <>
                        <h1>Plan Details</h1>
                        <div className="manage-order-container">
                            <div className="manage-order-detail grid-2-1fr-column">
                                <SelectField label="ACCOUNT TYPE"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                <InputField label="PLAN NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="Effective DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                <SelectField label="CONTRACT NAME"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <SelectField label="PLEASE SELECT STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <SelectField label="PLAN TYPE"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <InputField label="SERVICE TYPE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="CURRENCY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="Expiration DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>    
                                <InputField label="Service Type" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Contry/Location" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            </div>
                        </div>
                        <h1>Plan Values</h1>
                        <div className="manage-order-container">                          
                            <div className="manage-order-detail grid-2-1fr-column">                               
                                <InputField label="UNIT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <TextArea customClass="grid-item-span-3" label="Field Label" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />  
                                                        
                                <InputField label="RATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  /> 
                                                                                         
                                <InputField label="UNIT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                                               
                            </div>

                        </div>  
                        <h1>Plan Values</h1>
                        <div className="nocontract-details-container">
                            <span>No contract attribute</span>
                        </div>
                        <div>  
                            {this.state.detailsDropdown.map((details,index)=>{                                
                                 return  <CustomDropdown label={details.title} key={index}>                                                              
                                        <div className="grid-2-1fr-column mb-2">
                                        <SelectField label={details.subTitle}  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                            <div className="add-button-container ">
                                                <Button>Cancel</Button>
                                                <Button onClick={()=>this.showTable(index)}>Add</Button>
                                            </div>                
                                        </div>
                                        {
                                            details.showTable && 
                                            <DetailsDataTable datatable={details.dataTable} haveEditBtn={false} haveDeleteBtn={false} />       
                                        }
                                    </CustomDropdown>                              
                            })}
    
                        </div>                         
            </>
        )
    }
}